export var getIsFirstPickup = function (state) { return state.location.firstPickupCreation; };
export var getFirstPickupWrongZipCode = function (state) {
    return state.location.firstPickupWrongZipCode;
};
export var getLocations = function (state) { return state.location.locations; };
export var getLocationsCount = function (state) { return state.location.locationsCount; };
//# sourceMappingURL=location.js.map